export class VoyageOption {
    constructor(voyageNumber: string, firstPortCall: string, lastPortCall: string, status: string) {
        this.voyageNumber = voyageNumber;
        this.firstPortCall = firstPortCall;
        this.lastPortCall = lastPortCall;
        this.status = status;
    }
    voyageNumber: string;
    firstPortCall: string;
    lastPortCall: string;
    status: string;
}
